// Generated by Avo VERSION 231.100.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
var AvoEnv = /*#__PURE__*/ function(AvoEnv) {
    AvoEnv["Prod"] = "prod";
    AvoEnv["Dev"] = "dev";
    return AvoEnv;
}({});
let __AVO_ENV__ = null;
// @ts-ignore
let __AVO_NOOP__ = false;
// @ts-ignore
let __AVO_LOGGER__ = null;
// @ts-ignore
let __REPORT_FAILURE_AS__ = null;
// @ts-ignore
let __WEB_DEBUGGER__ = true;
const avoInspectorApiKey = "0EK2wgZRRlNgpZrE3dVz";
let __INSPECTOR__ = null;
let InternalAvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties) {
        const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);
        if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
            return;
        }
        typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
    },
    log: function log(message) {
        if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
            return;
        }
        typeof console !== 'undefined' && console.log("[avo] " + message);
    },
    warn: function warn(message) {
        if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
            return;
        }
        typeof console !== 'undefined' && console.warn("[avo] " + message);
    },
    error: function error(message, error) {
        if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
            return;
        }
        typeof console !== 'undefined' && console.error("[avo] " + message, error);
    }
};
function convertPropertiesArrayToMap(propertiesArray) {
    let result = {};
    propertiesArray.forEach((value)=>{
        result[value.name] = value.value;
    });
    return result;
}
let _avo_invoke;
let _avo_invoke_meta;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
    // @ts-ignore
    if (typeof window === 'undefined') {
        return;
    }
    if (_avo_sampling_rate > 0) {
        if (Math.random() < _avo_sampling_rate) {
            // @ts-ignore
            fetch("https://api.avo.app/i", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "ac": "X0Z5XYFLwR3lyazThssB",
                    "br": "master",
                    "en": env,
                    "ev": eventId,
                    "ha": hash,
                    "sc": "LUdm3yClzyKtZ3VfmBf2",
                    "se": new Date().toISOString(),
                    "so": "sPisQrkN-OQ_ue9vnEXIa",
                    "va": messages.length === 0,
                    "me": messages,
                    "or": origin
                })
            }).then(function(res) {
                return res.json();
            }).then(function(data) {
                _avo_sampling_rate = data.sa;
            }).catch(function() {});
        }
    }
};
_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
    // @ts-ignore
    if (typeof window === 'undefined') {
        return;
    }
    if (_avo_sampling_rate > 0) {
        if (Math.random() < _avo_sampling_rate) {
            // @ts-ignore
            fetch("https://api.avo.app/i", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "ac": "X0Z5XYFLwR3lyazThssB",
                    "br": "master",
                    "en": env,
                    "ty": type,
                    "sc": "LUdm3yClzyKtZ3VfmBf2",
                    "se": new Date().toISOString(),
                    "so": "sPisQrkN-OQ_ue9vnEXIa",
                    "va": messages.length === 0,
                    "me": messages,
                    "or": origin
                })
            }).then(function(res) {
                return res.json();
            }).then(function(data) {
                _avo_sampling_rate = data.sa;
            }).catch(function() {});
        }
    }
};
let _avo_debugger_log;
let _avo_debugger_events_during_boot = [];
let _avo_debugger_ready = false;
if (typeof window !== 'undefined') {
    window.addEventListener("message", function(event) {
        if (event.origin !== "https://www.avo.app") {
            return;
        }
        let iframe = document.getElementById("avo-debugger");
        if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
            iframe.style = event.data.style;
        } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
            let message = {
                type_: "avo-debugger-boot-events",
                schemaId: "LUdm3yClzyKtZ3VfmBf2",
                href: window.location.href,
                events: _avo_debugger_events_during_boot
            };
            _avo_debugger_events_during_boot = [];
            _avo_debugger_ready = true;
            iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger");
        }
    });
}
_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties, groupProperties) {
    if (typeof window === 'undefined') {
        return;
    }
    let event = {
        eventId: eventId,
        eventName: eventName,
        messages: messages,
        timestamp: Date.now(),
        eventProperties,
        userProperties,
        groupProperties
    };
    if (_avo_debugger_ready) {
        let message = {
            type_: "avo-debugger-events",
            events: [
                event
            ]
        };
        document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger");
    } else {
        _avo_debugger_events_during_boot.push(event);
    }
};
function _avo_debugger_send_position(position) {
    if (typeof window === 'undefined') {
        return;
    }
    window.addEventListener("message", function(event) {
        if (event.origin !== "https://www.avo.app") {
            return;
        }
        if (event.data.type_ === "avo-debugger-ready" && position !== null) {
            var message = {
                type_: "avo-debugger-position",
                position: position
            };
            document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger");
        }
    });
}
const UserStatus = {
    'LOGGED_IN': 'logged_in',
    'LOGGED_OUT': 'logged_out'
};
const ConsentStatus = {
    'DENIED': 'denied',
    'GRANTED': 'granted',
    'PENDING': 'pending'
};
const Language = {
    'FR': 'fr',
    'DE': 'de',
    'EN': 'en',
    'NL': 'nl'
};
const DeviceType = {
    'DESKTOP': 'desktop',
    'MOBILE': 'mobile',
    'TABLET': 'tablet'
};
let IWTTrackingBFF;
function initAvo(options, destinationOptions, IWTTrackingBFFDestination) {
    if (__AVO_ENV__ !== null) {
        return;
    }
    __AVO_ENV__ = options.env;
    if (options.avoLogger !== undefined) {
        __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
        __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == "prod") {
        InternalAvoLogger.warn("[avo] ****************************************************");
        InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
        InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
        InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
        InternalAvoLogger.warn("[avo] ****************************************************");
        __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
        InternalAvoLogger.log("[avo] ****************************************************");
        InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
        InternalAvoLogger.log("[avo] - No events will be sent");
        InternalAvoLogger.log("[avo] - No network requests are made");
        InternalAvoLogger.log("[avo] ****************************************************");
    }
    if (options.strict !== undefined) {
        options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
        __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = !__AVO_NOOP__ && (typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1 || options.webDebugger !== false && __AVO_ENV__ !== "prod");
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
        __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== 'prod') {
        InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
    }
    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
        if (options.webDebuggerOptions?.position) {
            _avo_debugger_send_position(options.webDebuggerOptions.position);
        }
        (function() {
            if (typeof window === 'undefined') {
                return;
            }
            let init = function() {
                let iframe = document.createElement("iframe");
                document.body.appendChild(iframe);
                iframe.id = "avo-debugger";
                iframe.src = "https://www.avo.app/_debugger";
                iframe.style = "display: none;";
            };
            if (document.body) {
                init();
            } else {
                document.addEventListener('DOMContentLoaded', init);
            }
        })();
    }
    if (!__AVO_NOOP__) {
        IWTTrackingBFF = IWTTrackingBFFDestination;
        if (__AVO_ENV__ === 'prod') {
            IWTTrackingBFF && IWTTrackingBFF.make && IWTTrackingBFF.make(__AVO_ENV__, null);
        } else if (__AVO_ENV__ === 'dev') {
            IWTTrackingBFF && IWTTrackingBFF.make && IWTTrackingBFF.make(__AVO_ENV__, null);
        } else {
            console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for IWT Tracking BFF. Head to destination settings in Avo to set a staging key.");
            IWTTrackingBFF && IWTTrackingBFF.make && IWTTrackingBFF.make(__AVO_ENV__, null);
        }
        if (__AVO_ENV__ === "dev") {
            // debug console in Avo
            _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
        }
    }
}
var Avo = {
    AvoEnv,
    initAvo,
    avoInspectorApiKey,
    UserStatus,
    ConsentStatus,
    Language,
    DeviceType
} // AVOMODULEMAP:"Avo"
 // AVOEVENTMAP:["viewPage","clickClassified"]
;

var AvoRuntime = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AvoEnv: AvoEnv,
  ConsentStatus: ConsentStatus,
  DeviceType: DeviceType,
  get IWTTrackingBFF () { return IWTTrackingBFF; },
  InternalAvoLogger: InternalAvoLogger,
  Language: Language,
  UserStatus: UserStatus,
  get __AVO_ENV__ () { return __AVO_ENV__; },
  get __AVO_LOGGER__ () { return __AVO_LOGGER__; },
  get __AVO_NOOP__ () { return __AVO_NOOP__; },
  get __INSPECTOR__ () { return __INSPECTOR__; },
  get __REPORT_FAILURE_AS__ () { return __REPORT_FAILURE_AS__; },
  get __WEB_DEBUGGER__ () { return __WEB_DEBUGGER__; },
  get _avo_debugger_log () { return _avo_debugger_log; },
  get _avo_invoke () { return _avo_invoke; },
  get _avo_invoke_meta () { return _avo_invoke_meta; },
  avoInspectorApiKey: avoInspectorApiKey,
  convertPropertiesArrayToMap: convertPropertiesArrayToMap,
  default: Avo,
  initAvo: initAvo
});

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Event hashes for Inspector tracking
const EVENT_HASH_DSnuQELVg8gkLu8HWOP8H_405ed346 = "97c638bc81082a0d7ccabc0931e0fc73c2056c47ab83a9338d624173704f31dc";
const EVENT_HASH_fG7guNrCl6n0ng8vF24K2_296b8fd1 = "0437354fc725e3e04316fe47f78d1c8b00502ad72e345edd3f46e3eb10dfd93c";

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * view_page: Every page load or URL change
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/1GKPyioa3SO2vM1itbxSp
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/J6X3V1QXGexucf_CwxI2s
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/pTgzRg5VrBgefV-rimGVT
 * 4. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/ROPhIsnvIsLRsUlXDyiMR
 * 5. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/UaA3aWY6m4f9Kz0I2O2UJ
 * 6. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/emhC1EaS5TAxA1iU2QjO5
 * 7. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/lT4SUN1CXOrOIIyHgJ0J6
 * 8. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/qZjgyKdl_EOqOu_QGkBxB
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H}
 */ function viewPage(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "DSnuQELVg8gkLu8HWOP8H", EVENT_HASH_DSnuQELVg8gkLu8HWOP8H_405ed346, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("view_page", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("DSnuQELVg8gkLu8HWOP8H", "view_page", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_page", eventProperties, "DSnuQELVg8gkLu8HWOP8H", EVENT_HASH_DSnuQELVg8gkLu8HWOP8H_405ed346);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("view_page", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * click_classified: Fired when a user clicks on a listing card on the SERP to open the CDP.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/fG7guNrCl6n0ng8vF24K2/trigger/CyZ3L6Zr37NeZj0SfdHX4
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/fG7guNrCl6n0ng8vF24K2/trigger/4c2KqpkvsexitWwY2IlWo
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/fG7guNrCl6n0ng8vF24K2/trigger/asMzgolzNSA57_zpPz4eZ
 * 
 * @param properties the properties associated with this event
 * @param properties.itemId: Unique listing identifier. Classified ID. 
 * From it, item-specific data is attached like:
 * index
 * name
 * list_name
 * id
 * price
 * estate_type
 * distribution_type
 * country
 * city
 * region
 * province
 * currency
 * zip_code
 * building_state
 * legacy_id
 * product_type
 * client_id (on item level)
 * energy_certificate (on item level)
 * promotion
 * etc.
 * @param properties.itemPosition: Position context if applicable
 * @param properties.listName: Context identifier for the list displayed
 * @param properties.listPosition: Position of the list on the page/screen, in relation to all the other lists on the page/screen.
 * Starting from 1
 * @param properties.listPageNumber: Results page number, starting from 1
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/fG7guNrCl6n0ng8vF24K2}
 */ function clickClassified(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "YLr4h04h9TEzHecxTJPE5",
        name: "item_id",
        value: properties.itemId
    });
    eventPropertiesArray.push({
        id: "jXrS-V2GLqLi3c10J62z3",
        name: "item_position",
        value: properties.itemPosition
    });
    eventPropertiesArray.push({
        id: "-iXATsEeE-QF75Hb1n21c",
        name: "list_name",
        value: properties.listName
    });
    properties.listPosition !== undefined && properties.listPosition !== null ? eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: properties.listPosition
    }) : eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: null
    });
    properties.listPageNumber !== undefined && properties.listPageNumber !== null ? eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: properties.listPageNumber
    }) : eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: null
    });
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "fG7guNrCl6n0ng8vF24K2", EVENT_HASH_fG7guNrCl6n0ng8vF24K2_296b8fd1, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("click_classified", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("fG7guNrCl6n0ng8vF24K2", "click_classified", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click_classified", eventProperties, "fG7guNrCl6n0ng8vF24K2", EVENT_HASH_fG7guNrCl6n0ng8vF24K2_296b8fd1);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("click_classified", Object.assign({}, eventProperties));
    }
}

// Only initialize avo-inspector on client-side to avoid SSR errors
const inspectorInstance = typeof window === "undefined" ? Promise.resolve(undefined) : import('avo-inspector').then((Inspector)=>{
    return new Inspector.AvoInspector({
        // Todo: potentially move this to env variable
        apiKey: "0EK2wgZRRlNgpZrE3dVz",
        env: Inspector.AvoInspectorEnv.Dev,
        version: "1.0.0",
        appName: "avo tracking"
    });
});

export { Avo, AvoEnv, clickClassified, inspectorInstance, viewPage };
